import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { ScreeningService } from '../services/screening.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { PhonePipe } from '../pipes/phone.pipe';
import { ClientService } from '../services/client.service';
import { ApplicantDataService } from '../services/applicant-data.service';
import { Subject, Subscription, identity } from 'rxjs';
import { ScreeningLight, ScreeningAdditionalData } from '../models/screeningInvite';
import { SsnPipe } from '../pipes/ssn.pipe';
import * as moment from 'moment' 
import { States, StateRecord} from '../models/statesArray';
import { DomSanitizer } from '@angular/platform-browser';
import { GroupedApplicantData } from '../models/ApplicantDataModels/GroupedApplicantData';
import { CreditRepositories } from '../models/ApplicantDataResponses/credit';
import * as _ from 'lodash';
import { ArgyleIncomeStream, DraftIncomeSource } from '../models/argyle';
import { ArgyleViewBag } from '../models/argyle';
import { COMPLIANCE_DISCLAIMER_CATALOG, ComplianceDisclaimerBlock } from '../models/ComplianceDisclaimers';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.less']
})
export class ReportComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    try {
      this.sub.unsubscribe();
      this.sub2.unsubscribe();
    } catch (error) {
      
    }
  }

  _groupIncome : number;
  _groupRent : number;
  
  public get groupIncome() : number {
    if(this.applicantData.groupedApplicantRecords && !this._groupIncome && this.applicantData.groupIncome)
    {
      //RIQ-4286: all incomes should be summed now
      //leaving the below in case we need it down the line? Dave flag this in PR if you think we should just ditch the old stuff
      // this._groupIncome = this.applicantData.groupedApplicantRecords.map(gar => {return gar.monthlyIncome}).reduce((partialSum, a) => partialSum + a, 0);
      this._groupIncome = this.applicantData.groupIncome.income.monthlyIncome; 
      // if(this.applicantData.groupedApplicantRecords.filter(gr =>{ return gr.apiVendor != 0;}).length > 0)
      // else{
      //   var sorted = this.applicantData.groupedApplicantRecords.sort((a,b)=>{
      //     if(a.screeningId < b.screeningId) return 1;
      //     else return -1;
      //   });
      //   this._groupIncome = sorted[0].monthlyIncome;
      // }
    }
    return this._groupIncome ?? 0;
  }
  
  
  public get groupRent() : number {
    if(this.applicantData.groupedApplicantRecords && !this._groupRent)
    {
      if(this.applicantData.groupedApplicantRecords.filter(gr =>{ return gr.apiVendor != 0;}).length > 0){
        var rents = this.applicantData.groupedApplicantRecords.map(gar => {return gar.rent});
        this._groupRent = Math.min.apply(Math,rents);
      }else{
        var sorted = this.applicantData.groupedApplicantRecords.sort((a,b)=>{
          if(a.screeningId < b.screeningId) return 1;
          else return -1;
        });
        this._groupRent = sorted[0].rent;
      }

      
    }
    
    return this._groupRent;
  }

  get incomeStreams(): ArgyleIncomeStream[] {
    return this.applicantData.incomeData?.streams ?? [];
  }

  get includedDraftSources(): DraftIncomeSource[] {
    return this.applicantData.draftSources.filter((d) => !d.isExcluded);
  }

  get excludedDraftSources(): DraftIncomeSource[] {
    return this.applicantData.draftSources.filter((d) => d.isExcluded);
  }

  public get showNYCrimDisclaimer() : boolean {
    if(this.instance.applicantState.toLowerCase() == 'ny' && this.applicantData.hasVisibleCriminalRecords) return true;
    return false;
  }
  

  listner$ : Subject<any>;
  sub : Subscription;

  listner2$ : Subject<any>;
  sub2 : Subscription;

  sub3 : Subscription;

  crimRecSub: Subscription;

  screeningListner$ : Subject<any>;
  screeningsub : Subscription;
  token: string;
  loaded : boolean = false;
  instance : ScreeningLight;
  showFullReport : boolean = true;

  reportDisclaimers : string[] = [];
  activeComplianceDisclaimers: ComplianceDisclaimerBlock[] = [];
  readonly complianceDisclaimerCatalog: ComplianceDisclaimerBlock[] = COMPLIANCE_DISCLAIMER_CATALOG;
  private lastComplianceScreeningId: number = 0;
  private hasFetchedComplianceMarkers: boolean = false;

  constructor(public datePipe: DatePipe,
    public ssn: SsnPipe, 
    public screening : ScreeningService, 
    public activatedRoute: ActivatedRoute, 
    public auth : AuthService,
    public toast : ToastrService, 
    public phonePipe : PhonePipe, 
    private location : Router,
    private applicantData : ApplicantDataService,
    public domSanitizer: DomSanitizer) 
    {
    }
    
 

  ngOnInit() {
    console.warn(this.location.url);
    this.activatedRoute.paramMap.subscribe((p : ParamMap) => {
      this.token = p.get('token');
      
      this.applicantData.token = this.token;
      if(!this.applicantData.screeningInvite) this.applicantData.FetchApplicantInviteNoPW(true);
      else{
        this.screening.GetScreeningLight().subscribe(s =>{
          this.screening.FetchScreeningAdditionalData(s.id).subscribe((scc: ScreeningAdditionalData[]) =>{
            this.applicantData.aseData = scc;
            if(this.applicantData.creditASEId) this.applicantData.LoadCreditData();
            this.instance = Object.assign(new ScreeningLight(),s);
            this.loadComplianceMarkers(this.instance.screeningId);
            console.info('ADTL DATAS: ', scc);
            this.instance.additionalData = scc;
            this.loaded = true;
            this.token = this.instance.screeningToken;
            this.showFullReport = this.instance.showFullReport ? this.instance.showFullReport : true;
            console.log(this.instance)
            //RIQ-4122:
            //this.applicantData.GetAddressRecordsForApplicant(this.instance.screeningId);
            //this.applicantData.GetAliasNameRecordsForApplicant(this.instance.screeningId);
          
          })
        
        },err=> {
          this.toast.error('Error loading report');
        })
      }
    });

    this.listner2$ = this.applicantData.dataLoaded;
    this.sub2 = this.listner2$.subscribe(s => {
      
      this.screening.GetScreeningLight().subscribe(s =>{
        
        this.screening.FetchScreeningAdditionalData(s.id).subscribe((scc: ScreeningAdditionalData[]) =>{
          this.applicantData.aseData = scc;
          if(this.applicantData.creditASEId) this.applicantData.LoadCreditData();
          let crimSrchs = scc.filter(sad =>{ return sad.searchType == 'Criminal'});
          crimSrchs.forEach(cs =>{
            this.applicantData.GetCriminalRecordsForApplicant(cs.searchEntryId);
          });

          let evicSrchs = scc.filter(sad =>{ return sad.searchType == 'Eviction' || sad.searchType == "EvictionVerification"});
          evicSrchs.forEach(cs =>{
            this.applicantData.GetEvictionRecordsForApplicant(cs.searchEntryId, cs.searchType);
          });

          

          let resVer = scc.filter(res => { return res.searchType == 'ResidenceVerification' });
          resVer.forEach(rec => {
            this.applicantData.GetReferenceVerifications(rec.searchEntryId);
          })

          let empVer = scc.filter(res => { return res.searchType == 'Employment' });
          empVer.forEach(rec => {
            this.applicantData.GetEmploymentVerifications(rec.searchEntryId);
          })

          let customSrchs = scc.filter(sad => { return sad.searchType == 'Custom' });
          customSrchs.forEach(cus => {
            this.applicantData.GetCustomSearchResponseRecords(cus.searchEntryId);
          })

          let identity = scc.filter(sad =>{ return sad.searchType == 'IdentityVerification'});
          identity.forEach(cs =>{
            this.applicantData.GetIdentityVerificationData(cs.searchEntryId);
          });



          this.instance = Object.assign(new ScreeningLight(),s);
          this.loadComplianceMarkers(this.instance.screeningId);
          this.instance.additionalData = scc;
          console.info('ADTL DATAS: ', scc);
          this.loaded = true;
          this.applicantData.GetRRReasons(this.instance.screeningId);
          //RIQ-4122:
          this.applicantData.GetAddressRecordsForApplicant(this.instance.screeningId);
          //RIQ-5037: Load credit aliases for report
          this.applicantData.GetAliasNameRecordsForApplicant(this.instance.screeningId);
          // Try draft sources first; fall back to legacy streams if none exist
          this.applicantData.GetDraftSourcesForReport(this.instance.screeningId, this.instance.locationId).subscribe(
            (drafts) => {
              if (!drafts || drafts.length === 0) {
                this.applicantData.GetIncomeDataForReport(this.instance.screeningId);
              }
            },
            () => {
              // On error, fall back to legacy
              this.applicantData.GetIncomeDataForReport(this.instance.screeningId);
            }
          );
          this.applicantData.GetIncomeOverviewForReport(this.instance.screeningId);
          this.applicantData.GetIncomeSourcesForReport(this.instance.screeningId);

          this.token = this.instance.screeningToken;
          if(this.instance.coApp) {
            this.applicantData.GetGroupApplicantDataRecords(this.instance.groupId, this.instance.screeningId);
            this.applicantData.GetGroupIncome(this.instance.invitationId);
            this.applicantData.GetGroupScorePointLossFactors(this.instance.groupId);
            this.applicantData.GetGroupHardDeclineReasons(this.instance.groupId);
          }
          this.showFullReport = this.instance.showFullReport;
  

          if(this.instance.isInPrequalState) {           
            // RIQ-2429: previously the view flag was being used in a manner that matched prequal status. We can use this check instead and get rid of the param altogether
            //we have to override the prequal stuff because once we filter the addtl data, the check will fail
            this.instance.prequalOverride = true;
            this.instance.additionalData = this.instance.additionalData.filter(rec => {return rec.searchType == 'Credit'});
          }
        })
      

      },err=> {
        this.toast.error('Error loading report');
      })
    });

    this.sub3 = this.applicantData.groupHardDeclineReasonsLoaded.subscribe(s => {
      if(this.applicantData._groupHardDeclineReasons && !this.instance.isInPrequalState && this.applicantData._groupHardDeclineReasons.find(r => r.displayMessage.includes("CRIMINAL"))) {
        this.addReportDisclaimer("Review Records Found. If your viewing permissions are limited, your Account Administrators have access to the entire consumer report as needed for any applicable Individualized Assessment.");  
      }
    });
    
    //SCRSTP-1715: if an INDIVIDUAL has visible criminal records, show the disclaimer.
    this.crimRecSub = this.applicantData.criminalRecordsLoaded.subscribe(s => {
      if(s === true && this.applicantData.hasVisibleCriminalRecords && !this.instance.isInPrequalState) {
        this.addReportDisclaimer("Review Records Found. If your viewing permissions are limited, your Account Administrators have access to the entire consumer report as needed for any applicable Individualized Assessment.");
      }
    });
  }

  
  public get canShowCriminal() : boolean {
    if(this.instance.creditOnlyReport && this.applicantData.reportSummaryItems.length > 0 )
    {
      // If all the criminal searches are complete then we can show the sections since this is a prequal report.
      return this.instance.additionalData.filter(rc =>{return rc.searchType == 'Criminal'}).length == this.instance.additionalData.filter(rc =>{return rc.searchType == 'Criminal' && rc.searchStatus == 8}).length;
    }else
      return true;
  }
  

  getCreditRepositoryName() : string {
    let search = this.instance.additionalData.find(se => {return se.searchType == 'Credit';})
    if(search)
    {
      return `${this.applicantData.creditRepository.toUpperCase() + ' '}${search.searchName.replace('Search','Report').toUpperCase()}`;
    }
    else return '';
  }

  getNoResultsMessage(searchType : string, searchQualifier : string = null)
  {
    if(!this.applicantData.reportSummaryItems) return 'No Reportable Records Found.';
    let search = undefined;
    if(searchQualifier)
      search = this.applicantData.reportSummaryItems.find(se => {return se.searchType == searchType && se.searchQualifier == searchQualifier;});
    else  
      search = this.applicantData.reportSummaryItems.find(se => {return se.searchType == searchType; });

    if(search && search.alerts)
      return search.alerts;
    else
      return 'No Reportable Records Found.'
  }

  searchHasAlerts(searchType : string, searchQualifier : string = null) : boolean
  {
    if(!this.applicantData.reportSummaryItems) return false;
    let search = undefined;
    if(searchQualifier)
      search = this.applicantData.reportSummaryItems.find(se => {return se.searchType == searchType && se.searchQualifier == searchQualifier;});
    else  
      search = this.applicantData.reportSummaryItems.find(se => {return se.searchType == searchType; });

    return (search && search.alerts);
  }

  searchComplete(name : string, qualifier:string = null){
    if(qualifier)
      return (this.instance.additionalData.find(se => {return se.searchType == name && se.searchQualifier == qualifier;}).searchStatus == 8);
    else
      return (this.instance.additionalData.find(se => {return se.searchType == name;}).searchStatus == 8);
  }

  searchIncluded(name : string, qualifier:string = null){
    if(qualifier)
      return (this.instance.additionalData.find(se => {return se.searchType == name && se.searchQualifier == qualifier;}) != undefined);
    else
      return (this.instance.additionalData.find(se => {return se.searchType == name;}) != undefined);
  }

  getPmClasses(pm) {
    switch (pm) {
      case '0': {
        return {'grey': true};
        break;
      }
      case '1': {
        return {'green': true};
        break;
      }
      case '2': {
        return {'red': true};
        break;
      }
      case '3': {
        return {'red': true};
        break;
      }
      case '4': {
        return {'red': true};
        break;
      }
      case '5': {
        return {'red': true};
        break;
      }
      case '7': {
        return {'orange': true};
        break;
      }
      case '8': {
        return {'red': true};
        break;
      }
      case '9': {
        return {'red': true};
        break;
      }
      case 'C': {
        return {'green': true};
        break;
      }
      case 'UR': {
        return {'grey': true};
        break;
      }
      case 'X': {
        return {'grey': true};
        break;
      }
      default: {
        return {'grey': true};
        break;
      }
    }
  }

  getSearchJurisdiction(searchName : string) : string {
    let search = this.applicantData.packages[0].searches.find(srch => { return srch.name == searchName });

    //if the search is undefined, it was probably added after the fact, so just return an emtpy string until we can come back and refactor this
    if(search == undefined) return "";
    
    //check the meta for the search depth
    let depth = search.searchMeta['searchDepth'];
    if(depth == 1 || depth == 4) {
      return States.find(rec => {return rec.abbreviation == search.searchMeta['state']}).name.toUpperCase();
    } else if(depth == 0) {
      return `${States.find(rec => {return rec.abbreviation == search.searchMeta['state']}).abbreviation}-${search.searchMeta['county']}`;
    }
    else if(depth == 8){
      return "Utah";
    }
    else return "";
  }

  public get GroupConditionalVerbiage() : string {
    
    if(!this.applicantData.groupedApplicantRecords) return '';
    //RIQ-3080: if the group decision is a Deline, always return ONLY Decline
    if(this.applicantData.groupedApplicantRecords[0].groupDecision.toLowerCase().includes('decline')) return `Decline`;

    if(this.instance.conditionalVerbiage.length > 0 && this.applicantData.groupedApplicantRecords.length > 0 && this.applicantData.groupedApplicantRecords[0].groupDecision)
    {    
      // if(this.applicantData.groupedApplicantRecords[0].groupDecision.toLowerCase().includes('conditional')) return `Conditional`;
      // else {
        if(this.applicantData.groupedApplicantRecords[0].groupInPrequal) return `Pre-Qual ${this.applicantData.groupedApplicantRecords[0].groupDecision}`;
        else return this.applicantData.groupedApplicantRecords[0].groupDecision;
      // }
    }else
    {
      if(this.applicantData.groupedApplicantRecords.length > 0 && this.applicantData.groupedApplicantRecords[0].groupDecision) {
        if(this.applicantData.groupedApplicantRecords[0].groupInPrequal) return `Pre-Qual ${this.applicantData.groupedApplicantRecords[0].groupDecision}`;
        else return this.applicantData.groupedApplicantRecords[0].groupDecision;
      }
      else return 'Pending';
    }
  }

  
  public get groupScoreRecord() : GroupedApplicantData {
    if(this.applicantData.groupedApplicantRecords && this.applicantData.groupedApplicantRecords.length > 0 && this.applicantData.groupedApplicantRecords[0].groupId)
      return this.applicantData.groupedApplicantRecords[0];
    else
    {
      return new GroupedApplicantData();
    }
  }
  

  getRecordCountsForSearch(name : string, qualifier:string = null) : number{
    let retn : number = 0;
    let addy : ScreeningAdditionalData = null;
    if(qualifier)
      addy = this.instance.additionalData.find(se => {return se.searchType == name && se.searchQualifier == qualifier;});
    else
      addy = this.instance.additionalData.find(se => {return se.searchType == name;});

    switch (name) {
      case 'Eviction':
        retn = this.applicantData.evictionRecords.length;
        break;
      case 'EvictionVerification':
        retn = this.applicantData.evictionVerificationRecords.length;
        break;
      case 'Alias':
        retn = this.applicantData.aliasRecords.length;
        break;
      case 'Address':
        retn = this.applicantData.addressRecords.length;
        break;
      case 'Custom':
        //RIQ-2023: if a custom search is marked as Record Found, we need to utilize the vendorRecordCount to reflect that
        if(addy && addy.vendorRecordCount) retn = addy.vendorRecordCount;
        break;
      case 'Credit':
        if(addy && addy.responseRecieved) retn = 1;
        break;
      case 'Employment':
        if(addy && addy.responseRecieved) retn = 1;
        break;
      case 'Person':
        if(addy && addy.responseRecieved) retn = 1;
        break;
      case 'ResidenceVerification':
        if(addy && addy.responseRecieved) retn = 1;
        break;
      case 'Criminal':
        if(addy && addy.responseRecieved)
        {
          if(addy.searchQualifier == 'multistate')  retn = this.applicantData.criminalRecords.length;
          if(addy.searchQualifier == 'county')  retn = this.applicantData.countyCriminalRecords.length;
          if(addy.searchQualifier == 'singlestate')  retn = this.applicantData.stateCriminalDatabaseRecords.length;
          if(addy.searchQualifier == 'statewide')  retn = this.applicantData.stateCriminalCourtRecords.length;
          if(addy.searchQualifier == 'national_alias')  retn = this.applicantData.nationalAliasRecords.length;
          if(addy.searchQualifier == 'UtahDistrictCourtScrape')  retn = this.applicantData.utahDistrictCourtRecords.length;
          if(addy.searchQualifier == 'UtahJusticeCourtScrape')  retn = this.applicantData.utahJusticeCourtRecords.length;
        }
        break;
      default:
        break;
    }

    return retn;
  }

  public get screeningSSNYears() : string {
    if(this.applicantData.ssnYears && this.applicantData.ssnYears.length > 0) return this.applicantData.ssnYears[0];
    else return '';
  }

  public get GroupConditionalVerbiageText() : string {
    if(this.instance.conditionalVerbiage.length > 0 && this.applicantData.groupedApplicantRecords.length > 0 && this.applicantData.groupedApplicantRecords[0].groupDecision)
    {
      if(this.instance.conditionalVerbiage.length > 0 && this.applicantData.groupedApplicantRecords[0].groupDecision.toLowerCase().includes('conditional')) return `${this.instance.conditionalVerbiage[0].verbiage}`;
      else return null;
    }
  }

  public get IndividualConditionalVerbiage() : string {
    //SCRSTP-987: we only generate conditional verbiage when a property decision is set now.
    //SCRSTP-1286: update conditional verbiage checks to respect the propDecision
    // if(this.instance.conditionalVerbiage[0] && !this.instance.propertyDecision && this.instance.isConditional) return `Conditional`;
    if (this.instance.propertyDecision) return this.instance.propertyDecision;
    else return this.instance.isInPrequalState ? 'Pre-Qual ' + this.instance.recommendedDecision: this.instance.recommendedDecision;
  }

  public get IndividualConditionalVerbiageText() : string {
    if(this.instance.conditionalVerbiage[0] && this.instance.isConditional) return `${this.instance.conditionalVerbiage[0].verbiage}`;
    else return null;
  }
  
  //SCRSTP-1292: show a disclaimer under the top factors if there is a CRIM REC hard decline reason.
  //we may need additional disclaimers moving forward..
  public get showReportDisclaimers() : boolean {
    if(this.reportDisclaimers.length > 0 || this.instance.creditOnlyReport) return true;
    return false;
  }

  addReportDisclaimer(text : string) {
    //SCRSTP-1282: don't want to dupelicate any disclaimers, so check first THEN add
    if(!this.reportDisclaimers.find(r => r === text)) this.reportDisclaimers.push(text);
  }

  private loadComplianceMarkers(screeningId: number): void {
    if (!screeningId) {
      this.activeComplianceDisclaimers = [];
      return;
    }

    // Avoid duplicate marker fetches/recomputes for the same report load.
    if (this.lastComplianceScreeningId === screeningId && this.hasFetchedComplianceMarkers) {
      this.recomputeComplianceDisclaimers();
      return;
    }

    this.lastComplianceScreeningId = screeningId;
    this.hasFetchedComplianceMarkers = true;
    this.applicantData.GetComplianceMarkers(screeningId, () => this.recomputeComplianceDisclaimers());
  }

  private recomputeComplianceDisclaimers(): void {
    const markers = this.applicantData.complianceMarkers || [];
    const activeRules = new Set(
      markers
        .filter(m => {
          const applies = (m as any).Applies ?? (m as any).applies;
          const rule = (m as any).ComplianceRule ?? (m as any).complianceRule;
          return !!m && applies === true && !!rule;
        })
        .map(m => (((m as any).ComplianceRule ?? (m as any).complianceRule) as string).trim().toLowerCase())
    );

    this.activeComplianceDisclaimers = this.complianceDisclaimerCatalog.filter(
      d => d && d.rule && activeRules.has(d.rule.trim().toLowerCase())
    );
  }
}
